import { EActionAttribute, EColor, EIcon, EPosition, ESize } from '@core/type';

import { ButtonIcon } from '../button';
import { Box } from '../layout';
import { LinkTranslatedStyledAsLink } from '../link-translated';
import { PaginationLinkArrowProps } from './interface-pagination';

export const PaginationLinkArrow = ({
  query,
  keyRoute,
  isDouble,
  isLeft,
  label,
  ...restProps
}: PaginationLinkArrowProps) => (
  <Box as={EActionAttribute.LI} listStyleType={'none'}>
    <LinkTranslatedStyledAsLink keyRoute={keyRoute} query={query}>
      <ButtonIcon
        iconProps={{
          type: isDouble ? EIcon.ANGLE_DOUBLE : EIcon.ANGLE,
          orientation: isLeft ? EPosition.LEFT : EPosition.RIGHT,
          size: ESize.MD,
          flexShrink: 0,
        }}
        backgroundColor={EColor.SECONDARY}
        borderRadius={'50%'}
        width={28}
        height={28}
        display={'flex'}
        alignItems={'center'}
        justifyContent={'center'}
        transition={'none'}
        as={EActionAttribute.SPAN}
        aria-label={label}
        {...restProps}
      />
    </LinkTranslatedStyledAsLink>
  </Box>
);
